import type { TripPassengerTagRead } from 'src/common/external/bambi-api/bambiApi';
import { TagDisplay } from 'src/common/tags/TagDisplay/TagDisplay';

interface PassengerTagsDisplayProps {
  tags?: TripPassengerTagRead[] | null;
}

export function PassengerTagsDisplay({
  tags,
}: PassengerTagsDisplayProps): JSX.Element | null {
  if (!tags?.length) {
    return null;
  }

  return <TagDisplay tags={tags} />;
}
